const log = require("../shared_utils/log.js");

module.exports = function store(state, emitter) {
  emitter.on("select-info-page", (index) => {
    log("select-info-page", index);
    state.selectedInfoPage = index;
    emitter.emit("render");
  });

  emitter.on("toggle-glitch-category", (categoryId) => {
    log("toggle-glitch-category", categoryId);
    state.inventoryFilter = "";
    state.selectedGlitchCategories = [categoryId];
    emitter.emit("render");
  });

  emitter.on("toggle-inventory", () => {
    log("toggle-inventory");
    state.isMenuOpen = false;
    if (!state.toolbar || !state.toolbar.glitches || !state.toolbar.parts || !state.toolbar.items) {
      state.toolbar = {
        glitches: [],
        parts: [],
        items:[]
      }
    }
    state.isInventoryOpen = !state.isInventoryOpen;
    if (state.isInventoryOpen) {
      state.wasGamePlaying = state.isGamePlaying;
      emitter.emit("deselect-target");
      emitter.emit("pause");
    } else {
      state.selectedGlitchId =
        state.toolbar.glitches.find((g) => g.id === state.selectedGlitchId) ||
        null;
      state.selectedPartId =
        state.toolbar.parts.find((p) => p.id === state.selectedPartId) || null;
      if (state.wasGamePlaying) {
        emitter.emit("play");
      }
    }
    emitter.emit("render");
  });

  emitter.on("select-inventory-category", (category) => {
    log("select-inventory-category", category);
    state.selectedInventoryCategory = category;
    emitter.emit("render");
  });
  emitter.on("change-inventory-filter", (value) => {
    if (state.selectedGlitchCategories[0] === "all") {  
      state.inventoryFilter = value;
      emitter.emit("render");
    }
  });
};
